export default {
  getColunasDisponiveis(state) {
    return state.colunasDisponiveis.filter((coluna) => coluna.noExport !== true);
  },
  getColunasCambio(state) {
    return state.colunasDisponiveis.filter((coluna) => coluna.type === 'date');
  },
  getColunasDinamicas(state) {
    return state.colunasDinamicasCambio;
  },
};
